import { TabLayout } from "../layouts/TabLayout";
import { SotdaFinanceScreen } from "../redesign/live/FinanceScreen";

// 금융 허브 — 클로드디자인 finance 시안(SotdaFinanceScreen)으로 렌더.
// MBTI·자산·예산·시그니처·플레이 5영역 → 카드 클릭 시 하위 라우트 진입.
// design doc: 2026-05-22-sotda-ia-restructure §4 Phase B
export function FinancePage() {
  return (
    <TabLayout page="finance">
      <SotdaFinanceScreen />
    </TabLayout>
  );
}
